import { render, staticRenderFns } from "./ManageAcademyEvent.vue?vue&type=template&id=5b8ee2cf&scoped=true"
import script from "./ManageAcademyEvent.vue?vue&type=script&lang=js"
export * from "./ManageAcademyEvent.vue?vue&type=script&lang=js"
import style0 from "./ManageAcademyEvent.vue?vue&type=style&index=0&id=5b8ee2cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ee2cf",
  null
  
)

export default component.exports